// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"4031fb65","453":"21d7aa67"}[chunkId] + ".chunk.js";
};